import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import { getCallbacks } from '../../helper/helper';
import styles from '../../../build/styles';

var TabGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(TabGroup, _Component);

  function TabGroup() {
    _classCallCheck(this, TabGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(TabGroup).apply(this, arguments));
  }

  _createClass(TabGroup, [{
    key: "createClassName",
    value: function createClassName() {
      return [styles[this.props.alignment], this.props.className].join(' ').trim();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('ul', _extends({}, getCallbacks(this.props), {
        className: this.createClassName()
      }), this.props.children);
    }
  }]);

  return TabGroup;
}(Component);

export { TabGroup as default };
TabGroup.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
  alignment: PropTypes.oneOf(['isLeft', 'isCenter', 'isRight'])
};
TabGroup.defaultProps = {
  className: ''
};